import { Component, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DataSourceGrid } from '../utils/data-source-grid.component';
import { DataService } from '../utils/data.service';
import { MatPaginator, MatDialog, MatSort, MatTabGroup } from '@angular/material';
import { generalService } from '../services/general.service';
import { RetiroEfectivo } from '../models/retiro';
import * as moment from 'moment';
import { DatosGeneralesSAE } from '../datos-generales-SAE';
import { modalComponent } from '../utils/modal/modal.component';

@Component ({
  selector: 'my-retiros-component',
  templateUrl: 'retiros.component.html',
  styleUrls: ['./retiros.component.scss'],
  providers: [generalService]
})

export class RetirosComponent {
  public datosGeneralesSAE: any;
  public realizar: boolean = true;
  public historial: boolean = false;
  public retiroForm: FormGroup;
  public retiroModel: RetiroEfectivo;
  dataRetiros: DataSourceGrid | null;
  displayedColumns = ['columnaUno', 'columnaDos', 'columnaTres', 'columnaCuatro', 'columnaCinco'];
  public historialRetiros: Array<any>;
  public confirmacionRetiros: any[];
  public userData: any = JSON.parse(sessionStorage.getItem('user'));
  public sucursal:number = this.userData.ORGANIZATION_ID;
  public compania:number = this.userData.COMPANY_ID;
  public confirmacion: string = '';
  public submitRow: boolean = true;
  public cleanRow: boolean = false;
  public filtros: any;
  public mensaje: string = ' ';
  public desactivarBoton = false;
  public dataRetirosEdit: any[] = [];
  public modoEdit = false;
  public id_retito = 0;
  // Modal messages
  private readonly CONFIRM_DELETE_MSG = '¿Está seguro que desea eliminar el retiro?';

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;

  // Configuracion del daterangepicker
  locale: {
    format: 'DD-MM-YYYY', 
    separator: ' - ',
    applyLabel: 'Aceptar',
    firstDay: 1 };

  ranges: any = {
    'Hoy': [moment(), moment()],
    'Mes actual': [moment().startOf('month'), moment().endOf('month')],
    'Ultimos 2 meses': [moment().subtract(2, 'month').startOf('month'), moment(), moment()] };
  
  public dateRange: any = {
    startDate: moment().startOf('month'),
    endDate: moment()   };

  constructor(private _generalService: generalService,
              private formBuilder: FormBuilder,
              public dataService: DataService,
              public dialog: MatDialog  ){
    this.datosGeneralesSAE = DatosGeneralesSAE;
    this.datosGeneralesSAE.showSpinnerLoading = false;
    this.retiroForm = new FormGroup({});
    this.retiroModel = new RetiroEfectivo(); 
    this.historialRetiros = new Array();
    this.dataService.guardado = false;     
    this.filtros = {
      idSucursal: this.sucursal,
      rangoInicio: this.dateRange.startDate.format('YYYY-MM-DD'),
      rangoFinal: this.dateRange.endDate.format('YYYY-MM-DD') };
  }

  ngOnInit() {
    this.buildRetiroForm();
    this.retiroForm.reset();
    console.log(this.userData);
  }

  ngModelChange(valor){ 
    this.filtros.rangoInicio = valor.startDate.format('YYYY-MM-DD');
    this.filtros.rangoFinal = valor.endDate.format('YYYY-MM-DD');
    this.consultaRetiros(); 
  }

  showTab(retiro: boolean, tabla:boolean) {
    if (retiro === true){
      this.realizar = true;
      this.historial = false; }
    if (tabla === true){
      this.realizar = false;
      this.historial = true;
      this.consultaRetiros();  }
  }

  buildRetiroForm() {    
    this.retiroForm = this.formBuilder.group({
      montoRetiro: this.formBuilder.control(null, [Validators.required, Validators.max(9999999999.99), Validators.min(0.01)]),
      motivoRetiro: this.formBuilder.control(null, [Validators.required, Validators.maxLength(500)]),
      correoElectronico: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
      contrasenia: this.formBuilder.control(null, [Validators.required, Validators.maxLength(100)]),
    });
  }

  consultaRetiros() {
    let tipo = 'agregar';
    let string = "Retiro/consultaRetiros/";

    this._generalService.metodoCallParamsPutPost(tipo, this.filtros, string)
      .subscribe(result => {
        this.historialRetiros = JSON.parse(result);
        this.dataRetiros = new DataSourceGrid(this.historialRetiros, this.paginator, this.sort);
        if(this.historialRetiros.length <= 0)
          { $(".mat-row").remove(".mat-row"); }
        },
      error => {  console.log(<any>error);  }
    );
  }

  onSubmit(){
  //if (this.retiroModel.correoElectronico == this.correo) {
    this.datosGeneralesSAE.showSpinnerLoading = true;
    this.desactivarBoton = true;
    let tipo = 'agregar';
    let confirmar = 'Retiro/confirmacionRetiros/';
    if(this.modoEdit){
      this.retiroModel.DOCUMENT_ID = this.id_retito;
    }
    this.retiroModel.organizationId = this.sucursal;
    this._generalService.metodoCallParamsPutPost(tipo, this.retiroModel, confirmar)
      .subscribe(result => {
        this.confirmacionRetiros = JSON.parse(result);
        console.log(this.confirmacionRetiros);
        if (this.confirmacionRetiros.length == 1) {
          if(this.compania == this.confirmacionRetiros[0].compania && this.sucursal == this.confirmacionRetiros[0].sucursal) {
            this.submitRow = false;
            this.cleanRow = true;

            let insertar = 'Retiro/agregarRetiros/';
            this._generalService.metodoCallParamsPutPost(tipo, this.retiroModel, insertar)
              .subscribe( (result) => {
                if (result != '') {
                  this._generalService.toastCall(result.message); } 
                else {
                  if(this.modoEdit){
                    this._generalService.toastCall("Retiro actualizado exitósamente");
                  }else{
                    this._generalService.toastCall("Retiro agregado exitósamente");
                  }
                 
                  this.datosGeneralesSAE.showSpinnerLoading = false;
                  this.desactivarBoton = false;
                  this.consultaRetiros(); 
                }
                this.id_retito = 0;
              },
              (error) => {
                const errorMsj =  error as any;
                console.log(errorMsj); 
              }); 
          } else {
            this._generalService.toastCall("Es necesario pertener a la compañia o sucursal donde se hará el retiro"); 
            this.datosGeneralesSAE.showSpinnerLoading = false;
            this.desactivarBoton = false;
          }
        } else {
          this._generalService.toastCall("Usuario y/o contraseña incorrectos");
          this.datosGeneralesSAE.showSpinnerLoading = false;
          this.desactivarBoton = false; }
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj);
      });
    //}
    //else {
    //  this._generalService.toastCall("El correo de confirmación deber ser igual del usuario en sesión");}
  }

  onClean(){
    this.retiroForm.reset();
    this.submitRow = true;
    this.cleanRow = false;
    this.mensaje = ' ';
  }

  
  modificarRetiro(idRetiro: number){
    this.tabGroup.selectedIndex = 0;
    let tipo = 'agregar';
    this.retiroModel.DOCUMENT_ID = idRetiro;

    let insertar = 'Retiro/getDataRetirosEdit/';
    this._generalService.metodoCallParamsPutPost(tipo, this.retiroModel, insertar)
      .subscribe( (result) => {
        const tableResult = JSON.parse(result);
        this.dataRetirosEdit = tableResult; 

        if(this.dataRetirosEdit.length > 0){
          this.retiroForm.get('motivoRetiro').setValue(this.dataRetirosEdit[0].COMMENTS);
          this.retiroForm.get('montoRetiro').setValue(this.dataRetirosEdit[0].TOTAL);
          this.modoEdit = true;
          this.id_retito = this.dataRetirosEdit[0].DOCUMENT_ID;
        }else{
          this.modoEdit = false;
          this.id_retito = 0;
        }
       
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj); 
      }); 
  }

  confirmDelete(idRetiro: number) {
    this.dataService.modal = 'confirm';
    this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
  
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogRef = dialogModal;
  
    dialogModal.afterClosed().subscribe(result => {
      if (this.dataService.guardado) {
        this.deleterow(idRetiro);
      }
    });
}
  
  deleterow(idRetiro: number) {
    let tipo = 'agregar';
    this.retiroModel.DOCUMENT_ID = idRetiro;

    let insertar = 'Retiro/eliminarRetiros/';
    this._generalService.metodoCallParamsPutPost(tipo, this.retiroModel, insertar)
      .subscribe( (ok) => {
        this.consultaRetiros();
        setTimeout(() => {
          this._generalService.toastCall("El registro se dio de baja exitosamente");
        }, 500); 
      },
      (error) => {
        const errorMsj =  error as any;
        console.log(errorMsj); 
      }); 
  }

}


// WEBPACK FOOTER //
// ./src/app/retiros/retiros.component.ts